import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

import { OnDemandLongFormItemLayout } from '../../../tiles/OnDemandLongFormItemTile/OnDemandLongFormItemTile';
import { OnDemandShortFormItemLayout } from '../../../tiles/OnDemandShortFormItemTile/OnDemandShortFormItemTile';

export const styles = StyleSheet.create({
  wrapper: {
    height: Theme.appHeight,
    width: Theme.appWidth,
  },
});

export const CONSTANTS = {
  shortform: {
    ...OnDemandShortFormItemLayout,
  },
  longform: {
    ...OnDemandLongFormItemLayout,
  },
  continueWatching: {
    TILE_WIDTH: Theme.px(360),
    TILE_HEIGHT: Theme.px(540),
    TILE_SPACING: Theme.px(30),
  },
  rowSpacing: Theme.px(120),
  rowTitleSpacing: Theme.px(35),
  rowTitleHeight: Theme.px(48),
  topRowOffset: Theme.px(188),
  rowOffset: Theme.px(90),
};

export const fullSpacing = CONSTANTS.rowSpacing;
